<div class="container" id="container" *ngIf="finishedLoading">
    <div class="row">
        <div class="col-sm-12">
            <h4>Zusatzfunktionen</h4>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12 ">
            <div class="actionRow ">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                            {{i+1}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="ID">
                        <th mat-header-cell *matHeaderCellDef>
                            ID
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.accountOption.id}}
                        </td>
                    </ng-container>



                    <ng-container matColumnDef="optionName">
                        <th mat-header-cell *matHeaderCellDef>
                            Funktionsname
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.accountOption.optionName}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="displayName">
                        <th mat-header-cell *matHeaderCellDef>
                            Angezeigter Name
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.accountOption.displayName}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef>
                            Beschreibung
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.accountOption.description}}
                        </td>
                    </ng-container>




                    <ng-container matColumnDef="state">
                        <th mat-header-cell *matHeaderCellDef>
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            <mat-chip-set>
                                <mat-chip class="primaryChip" selected *ngIf="element.accountOption.state == 'ACTIVE' ">
                                    {{element.accountOption.state | translateState}}
                                </mat-chip>
                                <mat-chip disabled *ngIf="element.accountOption.state != 'ACTIVE' ">
                                    {{element.accountOption.state | translateState}}
                                </mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef>
                            Letzte Änderung am
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.accountOption.created | date:'dd.MM.yyy hh:mm'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                color="accent">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item [routerLink]="['edit', element.accountOption.id]">
                                    <span>Bearbeiten</span>
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                </table>
                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine
                    passenden
                    Einträge
                    gefunden...</span>
                <!-- <mat-paginator [length]="page.totalElements" class="paginator-centered  mat-elevation-z2"
                [pageSize]="page.size" [pageIndex]="page.number" (page)="loadPage($event)"
                [pageSizeOptions]="[6, 12, 24, 36]" *ngIf="page">
            </mat-paginator> -->
            </div>
            <button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['add']">
                <mat-icon>add</mat-icon>
            </button>
        </div>
  
    </div>
</div>



<div class="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>